import React from "react";
//#region types
import { WintSuperkollAPIModel } from "wint-api-client/dist/types";
import { RecurringInvoiceStateFlowProps } from "models/propTypes/invoicePropTypes";
//#endregion
//#region components
import { LinearStateFlowContainer, useMountedState } from "components/common";
import { useRecurringInvoiceService } from "serviceHooks";
//#endregion

const RecurringInvoiceStateFlow: React.FC<RecurringInvoiceStateFlowProps> = (props) => {
  const recurringInvoiceService = useRecurringInvoiceService();
  const { getMounted } = useMountedState();
  const { invoiceId } = props;

  const [states, setStates] = React.useState<WintSuperkollAPIModel.EntityStateLog[]>();

  React.useEffect(() => {
    recurringInvoiceService.getStateLogs(invoiceId).then((items) => {
      if (getMounted()) {
        setStates(items);
      }
    });
  }, [invoiceId]);

  return (
    <>{states && <LinearStateFlowContainer steps={states} translationKey={"Invoice.RecurringStateFlowState"} />}</>
  );
};

export default RecurringInvoiceStateFlow;
